import { FocusTrapFactory } from '@angular/cdk/a11y';
import { AfterContentInit, OnInit, OnDestroy, ElementRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TreeNode } from 'primeng-lts/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { PlycaDataService } from '../../../services/plyca.service';
import { PaginationDTO } from '../../api/PaginationModel';
import { OrganizationalUnitDTO } from '../../api/plyca-dtos';
import { generateRandomIdentifier } from '../../ui.service';
import { BaseComponent } from '../common/baseComponent/base.component';
import { HeaderActionsService } from '../common/sub-header/header-actions.service';
import { WaitLoadingService } from '../common/waitLoading/wait-loading.service';

import { HttpParams } from '@angular/common/http';

export class SearchSettingOrganizationalUnitDTOModal {
  organizationalUnit: OrganizationalUnitDTO;
}

@Component({
  selector: 'searchOrganizationalUnits',
  templateUrl: 'searchOrganizationalUnits.template.html'
})
export class searchOrganizationalUnitsComponent extends BaseComponent implements AfterContentInit, OnInit, OnDestroy {
  context: SearchSettingOrganizationalUnitDTOModal;
  loaded = false;

  filterValidityPeriod = false;
  parameters: any;

  treeModel: TreeNode[];

  // objeto seleccionado
  selectedObject: OrganizationalUnitDTO;
  windowHash: any;
  //  public helpService: HelpService
  constructor(
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private plycaService: PlycaDataService, private focusTrap: FocusTrapFactory,
    private headerActionsService: HeaderActionsService,
    private translate: TranslateService,
    private elem: ElementRef,
    private waitService: WaitLoadingService
  ) {
    super();

    if (dialogConfig?.data?.parameters) {
      this.parameters = dialogConfig.data.parameters;
      let params = dialogConfig.data.parameters;
      this.parameters = new HttpParams();

      for (let i = 0; i < params.length; i++) {
        let nameFilter = params[i].identifier;
        let valueFilter = params[i].value;
        if (valueFilter) {
          this.parameters = this.parameters.append(nameFilter, valueFilter);
        }
      }
    }
    if (dialogConfig.data && dialogConfig.data.filterValidityPeriod) {
      this.filterValidityPeriod = (dialogConfig.data.filterValidityPeriod === '1');
      if (this.filterValidityPeriod) {
        if (this.parameters === undefined) {
          this.parameters = new HttpParams();
        }
        this.parameters = this.parameters.append('currentOrganizationalUnits', true);
      }

    }
    this.context = dialogConfig['context'];
    if (this.context) {
      this.selectedObject = this.context.organizationalUnit;
    }

  }


  ngOnDestroy() {

    this.dialogConfig = null;

    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  ngOnInit() {
    this.waitService.startWaiting();
    this.windowHash = generateRandomIdentifier();

    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(
      this.headerActionsService.addWindowAction(this.translate.instant('General.cancel'), 'fas fa-times',
        'btn-secondary', true, this.windowHash),
      success => {
        this.cancel();
      });




  }

  ngAfterContentInit(): void {

    this.loadData();


    this.focusTrap.create(
      this.elem.nativeElement).focusLastTabbableElementWhenReady()
      .then(focussed => {
        console.log('**** Foco en -> ' + document.activeElement)
      });
    this.waitService.cancelWaiting();
  }



  loadData() {
    this.subscribe(this.plycaService.getOrganizationalUnits(this.parameters),
      (datos: PaginationDTO<OrganizationalUnitDTO>) => {
        this.treeModel = this.processTree(
          this.getRootsUO(datos.content),
          datos.content
        );
        this.expandAll();
        this.loaded = true;
      });
  }

  processTree(
    nodos: Array<TreeNode>,
    datos: Array<OrganizationalUnitDTO>
  ): Array<TreeNode> {
    nodos = nodos.sort((uo1, uo2) => (uo1.label < uo2.data.label ? -1 : 1));
    nodos.forEach(uo => {
      let childs = datos
        .filter(
          uo2 =>
            uo2.unitParent && uo.data.identifier === uo2.unitParent.identifier
        )
        .map(x => this.convertUO2Node(x));
      if (childs) {
        this.processTree(childs, datos);
        uo.children = childs;
      }
    });
    return nodos;
  }

  expandAll() {
    this.treeModel.forEach(node => this.expandRecursive(node, true));
  }

  collapseAll() {
    this.treeModel.forEach(node => this.expandRecursive(node, false));
  }

  private expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    // console.log('expanding', node);
    if (node.children) {
      node.children.forEach(childNode => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  // Devuelve como raiz aquellas unidades cuyo padre no está en la lista y la raíz (que no tiene padre)
  getRootsUO(datos: Array<OrganizationalUnitDTO>): Array<TreeNode> {
    return datos
      .filter(
        uo =>
          !uo.unitParent || !this.existParent(uo.unitParent.identifier, datos)
      )
      .map(x => this.convertUO2Node(x));
  }

  // Comprueba si la unidad padre esta en la lista de unidades
  existParent(parentId: string, datos: Array<OrganizationalUnitDTO>): boolean {
    return datos.find(uo => uo.identifier === parentId) !== undefined;
  }

  convertUO2Node(ou: OrganizationalUnitDTO): TreeNode {
    let nodo: TreeNode = {};
    nodo.label = ou.name;
    nodo.data = ou;
    nodo.children = [];
    return nodo;
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  cancel(): void {
    this.ref.close();
  }

  accept(selection: any): void {
    console.log('uo seleccionada', selection);
    this.ref.close(selection.node.data);
  }
}
